/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-06-06 16:24:27
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-04-22 16:53:00
 * @FilePath: \baishu_react_ui\src\components\BsyFormData\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';

import './index.css'

import { BsyWidget } from '../BsyWidget';

import BsyAlertMenu from '../BsyAlertMenu';


class BsyNavigator extends BsyWidget {
    constructor(props) {
        super({
            baseCls: "bsy-navigator",
            items: [],
            currentMenuId: null,
            onMenuClick: null,
            delay: 218,
            edge: 5,
            enable: !0,
            menuKey: null,
            ...props
        });
        this.state = {
            currentMenuId: props.currentMenuId,
        }
        this.ItemMap = {};
        props.items.map(e => {
            this.ItemMap[e.flowId] = e;
        })
    }

    componentDidMount() {
        super.componentDidMount();

    }

    click = (event) => {

        let that = this;
        const { items, menuKey } = this.options;
        const { currentMenuId } = this.state;
        let menu = [];
        items.map(e => {
            menu.push({
                text: e.name,
                colorType: "",
                extIcon: currentMenuId === e[menuKey] ? "icon-ok" : '',
                click: () => {
                    this.setState({
                        currentMenuId: e[menuKey]
                    }, () => {
                        this.props.onMenuClick && this.props.onMenuClick(this.state.currentMenuId)
                    })
                }
            })
        })

        BsyAlertMenu({
            item: menu,
            width: 'auto',
            target: event.target,
        })
        // BsyMsgBubble({
        //     anchor: event.currentTarget,
        //     contentHTML: (ref) => {

        //         return <div >
        //             {
        //                 items.map(e=>{
        //                     return <div className="item">
        //                         <span>{e.name}</span> {e.flowId == currentMenuId ? <i className="fa fa-"></i> : ''}
        //                     </div>
        //                 })
        //             }
        //         </div>
        //     }
        // })
    }

    render() {
        const { cssName, css } = this.options;
        const { currentMenuId } = this.state;;
        if(!this.ItemMap[currentMenuId]) {
            return '';
        }

        return (<div className={cssName}  >
            <div className="title" onClick={this.click}>
                <span>{this.ItemMap[currentMenuId].name}</span><i className="icon-angledown"></i>
            </div>
        </div>

        );
    }
}

export default BsyNavigator;
